module.exports = __webpack_public_path__ + "static/media/react.2e01c74f.svg";